import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { VendorListItem } from '../../../services/vendors';
import { vendorBlockLabel, vendorDispatchBlock } from './vendorDispatch';

function summaryText(vendor: VendorListItem): string {
    const { email, external } = vendor.orderMethods;
    const parts = [
        email > 0 ? `${email} email` : null,
        external > 0 ? `${external} portal` : null
    ].filter((part): part is string => part !== null);
    return parts.join(' · ');
}

// No usable method is the whole point of this column: such a vendor cannot be
// ordered from at all, so it reads as a warning rather than as a count of zero.
export function OrderMethodsCell({ vendor }: { vendor: VendorListItem }) {
    const block = vendorDispatchBlock(vendor);
    const { total, usable } = vendor.orderMethods;

    if (block === 'no_methods' || block === 'no_usable_method') {
        return (
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-rose-600">
                <ExclamationTriangleIcon className="h-4 w-4 shrink-0" />
                {vendorBlockLabel(block)}
            </span>
        );
    }

    return (
        <span className="flex flex-col">
            <span className="text-sm text-gray-800 tabular-nums">
                {usable} of {total} usable
            </span>
            <span className="text-[11px] text-gray-400 truncate">{summaryText(vendor)}</span>
        </span>
    );
}
